@if (showWidget) {
  <div class="chatbot-icon" (click)="openChatBot()">
    <ion-icon name="chatbubbles"></ion-icon>
  </div>
}

<ion-content>
  <div class="main-container">
    <ion-row class="main-header">
      <ion-col class="heading-wrap ion-no-padding" size="11">
        <h1 class="page-heading">{{ 'subscription.service' | translate }}
          {{ 'subscription.settings' | translate }}
        </h1>
      </ion-col>
      <ion-col class="notification-wrap ion-no-padding" size="1">
        <img (click)="goBack()" class="support-img" src="assets/images/close-circle.png" />
      </ion-col>
    </ion-row>
    <div class="links-card">
      @if (myOngoingSyndicates$ | async; as syndicateList) {
        <div>
          <h2 class="top-titles">{{ "subscription-settings.ongoing" | translate }}</h2>
          @for (syndicate of syndicateList; track syndicate; let in = $index) {
            <ion-card no-lines>
              <ion-item lines="none">
                <!--  -->
                @if (syndicate?.current_status === 'payment failed') {
                  <div class="card-status og-color tooltip p-fixed"
                    (mouseover)="toggleZIndex(true)" (mouseout)="toggleZIndex(false)">
                    {{ "subscription-tooltip.payment" | translate }}
                    <img alt="ongoing syndicate" class="support-img" src="assets/icon/alert_pay.svg" />
                    <span class="tooltiptext payment-tooltip width-20 color">
                      <div class="tooltip-icon toolimg">
                        <img alt="Running-icon" src="assets/icon/alert.svg" />
                      </div>
                      <div class="tooltip-desc titlecase-text text-alligment payment-head">
                        <div class="tooltip-title payment-bottom">
                          {{ "subscription-tooltip.payment_heading" | translate }}
                        </div>
                        {{ "subscription-tooltip.payment_desc" | translate }}
                      </div>
                    </span>
                  </div>
                }
                <!--  -->
                @if (syndicate?.current_status === 'running') {
                  <div class="card-status og-color tooltip">
                    {{ "subscription-settings.ongoing" | translate | uppercase}}
                    <img alt="ongoing syndicate" class="support-img" src="assets/icon/ongoing.png" />
                    <span class="tooltiptext">
                      <div class="tooltip-icon">
                        <img alt="Running-icon" src="assets/icon/running-icon.png" />
                      </div>
                      <div class="tooltip-desc">
                        <div class="tooltip-title"> {{ "subscription-tooltip.running" | translate }} </div>
                        {{ "subscription-tooltip.running_desc" | translate }}
                      </div>
                    </span>
                  </div>
                }
                @if (syndicate?.current_status === 'paused') {
                  <div class="card-status pd-color tooltip">
                    {{ "subscription-settings.paused" | translate | uppercase}}
                    <img alt="paused syndicate" class="support-img" src="assets/icon/paused.png" />
                    <span class="tooltiptext">
                      <div class="tooltip-icon">
                        <img alt="Paused-icon" src="assets/icon/pausedico.png" />
                      </div>
                      <div class="tooltip-desc">
                        <div class="tooltip-title"> {{ "subscription-tooltip.paused" | translate }} </div>
                        {{ "subscription-tooltip.paused_desc" | translate }} <span class="edtime"> <strong>
                        {{ syndicate?.next_resume_date ?
                        (syndicate?.next_resume_date?.toDate() | date: "d MMM yyyy") :
                      ("subscription-settings.resumeDateUnavailable" | translate) }} </strong></span>
                    </div>
                  </span>
                </div>
              }
              @if (syndicate?.current_status === 'holiday') {
                <div class="card-status sh-color tooltip">
                  <span style="color: #4698D8;">
                    {{ "subscription-settings.holiday" | translate | uppercase}}
                  </span>
                  @if (syndicate?.current_status==='holiday') {
                    <ion-icon class="status-icon" name="calendar-outline">
                    </ion-icon>
                  }
                  <span class="tooltiptext">
                    <div class="tooltip-icon">
                      <img alt="Paused-icon" src="assets/icon/holidayico.png" />
                    </div>
                    <div class="tooltip-desc">
                      <div class="tooltip-title"> {{ "subscription-tooltip.holiday" | translate }} </div>
                      {{ "subscription-tooltip.holiday_desc" | translate }}
                      <span class="edtime"><strong>
                        {{ syndicate?.next_resume_date ?
                        (syndicate?.next_resume_date?.toDate() | date: "d MMM yyyy") :
                      ("subscription-settings.resumeDateUnavailable" | translate) }} </strong></span>
                    </div>
                  </span>
                </div>
              }
              <ion-label>{{ syndicate?.ps_name ? syndicate?.ps_name : syndicate?.syndicate_name }} <br />
                <span>{{ syndicate?.products[0]?.total_lines }} {{ syndicate?.products[0]?.product_name }}
                  {{ "subscription.linesEvery" | translate }}
                </span>
                <div style="display: flex;flex-wrap: wrap;" fxLayoutGap="20px">
                  @for (product of syndicate?.products; track product; let i = $index) {
                    <span
                      [ngStyle]="{ 'margin-left': i > 0 ? '.5vh' : '0px' }">
                      {{ syndicate?.cardType === "Managed" ? ('dynamic_value.' + (transform(product?.draw_day))| translate)
                      :
                      ('dynamic_value.' + (transform(product?.draw_day[0]))| translate)}}
                    {{ i < syndicate?.products.length - 1 ? " and " : "" }} </span>
                  }
                </div>
                <br>
                  @if (syndicate?.current_status === 'paused') {
                    <div class="update-td">
                      <span class="edtime">{{ "subscription-settings.resumeDate" | translate }}: <strong>
                        {{ syndicate?.next_resume_date ?
                        (syndicate?.next_resume_date?.toDate() | date: "d MMM yyyy") :
                      ("subscription-settings.resumeDateUnavailable" | translate) }} </strong></span>
                    </div>
                  }
                  @if (syndicate?.current_status === 'holiday') {
                    <div class="update-td">
                      <span class="edtime">{{ "subscription-settings.billingDate" | translate }}: <strong>
                        {{ syndicate?.next_resume_date ?
                        (syndicate?.next_resume_date?.toDate() | date: "d MMM yyyy") :
                      ("subscription-settings.resumeDateUnavailable" | translate) }} </strong></span>
                    </div>
                  }
                </ion-label>
                <ion-toggle justify="end" (ionChange)="onTriggerToggleChange($event, syndicate)" color="secondary" [ngClass]="{'z-index-minus-one': isHovered}"
                  [checked]="syndicate.active" (click)="checkStatus(syndicate)" [(ngModel)]="syndicate.active"
                class="toggle-status theme-blue" mode="ios"></ion-toggle>
              </ion-item>
            </ion-card>
          }
        </div>
      } @else {
        @if (syndicateLoaded) {
          <ion-card>
            <ion-card-header>
              <img class="round-img" src="assets/images/round.png" />
            </ion-card-header>
            <ion-card-content>
              <p>{{ "subscription.noOngoing" | translate }}</p>
              <p><span class="color-primary" (click)="goToStore()">{{ "subscription.visitStore" | translate }} </span>
            {{"subscription.lotteries" | translate}}</p>
          </ion-card-content>
        </ion-card>
      } @else {
        <app-in-progress-animation></app-in-progress-animation>
      }
    }
  </div>
  <div class="links-card no-activated-card">
    <h2 class="top-titles">{{ "subscription.jackpotTriggers" | translate }}</h2>
    @if (myJackpots$ | async; as myJackpots) {
      <div>
        <ion-card no-lines>
          @for (trigger of myJackpots; track trigger) {
            <ion-item lines="none">
              <ion-label>
                <!-- {{ trigger?.jackpot_name }} Trigger <br /><span
                >{{ trigger?.lines }} Lines for £{{ trigger?.price.toFixed(2) }} when the <br />jackpot is above £{{
                trigger?.jackpot
                }}</span
                > -->
                {{ trigger?.jackpot_name }} {{"subscription.trigger" | translate}} <br /><span>{{ trigger?.lines }}
                {{"subscription.linesFor" | translate}} {{currencySymbol}}{{
                formatCurrencyDisplay(trigger?.int_price?.[preferredCurrency] ?? trigger?.price) }} {{ "subscription.whenThe" | translate }}
                <br />{{ "subscription.aboveJack" | translate }}
                {{currencySymbol}}{{trigger?.int_jackpot?.[preferredCurrency] ?
              trigger?.jackpot :trigger?.int_jackpot?.[preferredCurrency]}}</span>
            </ion-label>
            <ion-toggle [(ngModel)]="trigger.active" checked="{{ trigger.active }}" class="theme-blue"
              (click)="jackpotWarning(trigger)" (ionChange)="onTriggerToggleChange($event, trigger)" color="secondary"
            mode="ios"></ion-toggle>
          </ion-item>
        }
      </ion-card>
    </div>
  } @else {
    @if (jackpotLoaded) {
      <ion-card>
        <ion-card-header>
          <img class="power-img" src="assets/images/power.png" />
        </ion-card-header>
        <ion-card-content>
          <p>{{ "subscription.noTriggers" | translate }}</p>
          <p><span class="color-primary" (click)="goToStore()">{{ "subscription.visitStore" | translate }}
          </span>{{ "subscription.triggers" | translate }}</p>
        </ion-card-content>
      </ion-card>
    }
  }


</div>
</div>
</ion-content>
